// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import { NavLink } from 'react-bootstrap'
import './Intersticial.scss'

export interface ActionItems {
  label: string
  redirectTo: string
  variant?: string
  openInNewTab?: boolean
  customClass?: string
}

export interface IntersticialProps {
  title?: string
  subtitle?: string
  customTitle?: React.ReactNode
  customClass?: string
  actions?: ActionItems[] | []
  bottomAction?: ActionItems
}

const Intersticial: React.FC<IntersticialProps> = ({
  title,
  subtitle,
  customTitle,
  customClass,
  actions,
  bottomAction
}): JSX.Element => {
  return (
    <div className={`intersticial-container px-s7 py-s7 p-sm-s10 ${customClass ?? ''}`}>
      <div className="internal-container flex-column flex-sm-row gap-s8">
        <div className="intersticial-heading-container">
          {customTitle ? (
            <>{customTitle}</>
          ) : (
            <>
              <h2>
                <span className={`${(bottomAction ?? actions) ? 'display-5' : 'display-6'} d-none d-sm-block`}>
                  {title}
                </span>
                <span className="lead d-block d-sm-none">{title}</span>
              </h2>
              {subtitle && <span>{subtitle}</span>}
            </>
          )}
          {bottomAction && (
            <div className="pt-s5">
              <a
                className={
                  bottomAction?.variant === 'link'
                    ? `link ${bottomAction?.customClass ?? ''}`
                    : `btn btn-${bottomAction?.variant ?? 'outline-primary'} ${bottomAction?.customClass ?? ''}`
                }
                href={bottomAction?.redirectTo}
                target={bottomAction?.openInNewTab ? '_blank' : '_self'}
                rel={bottomAction?.openInNewTab ? 'noreferrer' : undefined}
                intc-id={`${bottomAction?.variant}-${bottomAction?.label}-${title}`.replaceAll(' ', '-')}
                data-wap_ref={`${bottomAction?.variant}-${bottomAction?.label}-${title}`.replaceAll(' ', '-')}
                role={bottomAction?.variant}
                aria-label={`Go to ${bottomAction?.redirectTo}`}
              >
                {bottomAction?.label}
              </a>
            </div>
          )}
        </div>
        {actions && (
          <div className="intersticial-buttons-container gap-s8 p-s4 flex-column flex-sm-row">
            {actions?.map((item: any, index: number) => {
              const intcId = item.label.replaceAll(' ', '-')
              return (
                <NavLink
                  key={index}
                  className={`btn btn-lg btn-${item?.variant ?? 'primary'}`}
                  href={item.redirectTo}
                  role="button"
                  intc-id={`btn-${intcId}`}
                  data-wap_ref={`btn-${intcId}`}
                  rel="noreferrer"
                  target={item.openInNewTab ? '_blank' : '_self'}
                >
                  {item.label}
                </NavLink>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default Intersticial
